/**
 * This middlware will intercept api actions
 * It will dispatch two actions for one API call : <API_ACTION_TYPE>_BEGIN at the start,
 * <API_ACTION_TYPE>_SUCCESS or <API_ACTION_TYPE>_ERROR depending on the result of the API call
 */
const fetchMiddleware = store => next => action => {
  const { api, type, ...rest } = action;
  //If it is not a API action, we can pass it to next step without doing anything
  if (!api) {
    return next(action);
  }
  next({ ...rest, type: type + '_BEGIN' });

  api
    .then(result => {
      next({ ...rest, result, type: type + '_SUCCESS' });
    })
    .catch(error => {
      next({ ...rest, error, type: type + '_FAILURE' });
    });
};

export default fetchMiddleware;
